import { getIsTouch, getIsPhone, getIsTablet, getIsDesktop, getIsSM, getIsMD, getIsLG } from './device.js';

export function global_vars() {
    const html = document.documentElement;
    const body = document.body;

    const isTouch = getIsTouch();
    const isPhone = getIsPhone();
    const isTablet = getIsTablet();
    const isDesktop = getIsDesktop();
    const isSM = getIsSM();
    const isMD = getIsMD();
    const isLG = getIsLG();
    const isHome = body.classList.contains('home');

    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    // Inicializar coordenadas
    const clientX = 0, clientY = 0, screenX = 0, screenY = 0, pageX = 0, pageY = 0;

    // Guardar en window.VARS
    window.VARS = {
        isTouch,
        isPhone,
        isTablet,
        isDesktop,
        isSM,
        isMD,
        isLG,
        isHome,
        windowWidth,
        windowHeight,
        clientX,
        clientY,
        screenX,
        screenY,
        pageX,
        pageY
    };

    // Añadir clases touch
    html.classList.toggle('is-touch', isTouch);
    html.classList.toggle('is-not-touch', !isTouch);

    return window.VARS;
}
